import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Typography } from '@mui/material';

interface AddTokensDialogProps {
  open: boolean;
  userId: number | string | undefined;
  onClose: () => void;
  onSubmit: (tokenCount: number) => void;
}

export const UsersAddTokensDialog: React.FC<AddTokensDialogProps> = ({ open, userId, onClose, onSubmit }) => {
  const [tokenCount, setTokenCount] = useState<number>(1);

  const handleSubmit = () => {
    if (tokenCount > 0) {
      onSubmit(tokenCount);
      setTokenCount(1);
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Add Tokens</DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
        <Typography>User ID: {userId}</Typography>
        <TextField
          label="Number of Tokens"
          type="number"
          value={tokenCount}
          onChange={e => setTokenCount(Number(e.target.value))}
          inputProps={{ min: 1 }}
          fullWidth
          margin="dense"
          required
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSubmit}>Add</Button>
      </DialogActions>
    </Dialog>
  );
};
